/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Studio_SubtitleInputs */

const cs_builder_studio_subtitle = /** @type {(inputs: Builder_Studio_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skládejte na plátně. Náhled zkompiluje PDF. Uložte v záhlaví. Generujte z inzerátu.`)
};

const en_builder_studio_subtitle = /** @type {(inputs: Builder_Studio_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compose on the canvas. Preview compiles a PDF. Save in the page header. Generate from a listing.`)
};

/**
* | output |
* | --- |
* | "Compose on the canvas. Preview compiles a PDF. Save in the page header. Generate from a listing." |
*
* @param {Builder_Studio_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_studio_subtitle = /** @type {((inputs?: Builder_Studio_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Studio_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_studio_subtitle(inputs)
	return cs_builder_studio_subtitle(inputs)
});